import Node from './Node';
import Path from './Path';
import Player from './Player';
import { PathMovementPayload } from './PathMovementPayload';
import BaseScene from '../scenes/BaseScene';

export default class PathMovement extends Phaser.GameObjects.Sprite {

    public origenNode: Node;
    public destineNode: Node;
    private relatedScene: BaseScene;
    private owner: Player;
    private path: Path;
    private payload: PathMovementPayload;
    private tween?: Phaser.Tweens.Tween;

    constructor(scene: BaseScene, origenNode: Node, destineNode: Node, path: Path, payload: PathMovementPayload) {
        super(scene, origenNode.originalX, origenNode.originalY, 'movement_villager');
        this.relatedScene = scene;
        this.origenNode = origenNode;
        this.destineNode = destineNode;
        this.owner = this.origenNode.player;
        this.path = path;
        this.payload = payload;

        // Draw on construct
        this.setFrameFromPayload();
        scene.add.existing(this);
        this.setDepth(5);

        // Configure physics & Collisions
        (scene.matter.add.gameObject(this) as Phaser.Physics.Matter.Sprite)
            .setRectangle(20, 20)
            .setCollisionGroup(this.owner.noCollisionGroup);
    }

    private setFrameFromPayload(): void {
        if (this.payload.counter <= 30) {
            this.setFrame(this.payload.counter - 1);
        } else {
            this.setFrame(30);
        }
    }

    public getPayload(): PathMovementPayload {
        return this.payload;
    }

    public execute() {
        if (!this.path.trace) {
            return;
        }

        // Determine movement direction
        const tInit = this.path.origenNode == this.origenNode ? 0 : 1;
        const tEnd = this.path.origenNode == this.origenNode ? 1 : 0;

        // Determine movement duration. Default 1000px / 1sec.
        const movementDuration = (this.path.trace.getLength() * 15) / this.relatedScene.getBootloaderScene().AppData.gameSpeedFactor();

        // Follower allow us to move the object with a Tween
        const follower = { t: tInit, vec: new Phaser.Math.Vector2() };

        this.tween = this.relatedScene.tweens.add({
            targets: follower,
            t: tEnd,
            ease: 'Sine.easeInOut',
            duration: movementDuration,
            repeat: 0,
            onUpdate: () => this.onUpdateMovement(follower),
            onComplete: () => this.finishMovement(),
        });

        this.origenNode.counter = this.origenNode.counter - this.payload.counter;
    }

    private onUpdateMovement(follower: any) {
        if (!this.path.trace) {
            return;
        }

        this.path.trace.getPoint(follower.t, follower.vec);
        this.x = follower.vec.x;
        this.y = follower.vec.y;
    }

    private finishMovement() {
        const targetPlayer = this.destineNode.player;

        // To same player
        if (this.owner == targetPlayer) {

            this.destineNode.counter += this.payload.counter;
        }

        if (this.owner != targetPlayer) {
            const necessaryPointToTakeNode = Math.round(this.destineNode.counter * this.destineNode.config.defensivePower);

            // Capture Node
            if (this.payload.counter > necessaryPointToTakeNode) {

                this.payload.counter -= necessaryPointToTakeNode;
                targetPlayer.decreasePopulation(this.destineNode.counter);
                this.owner.decreasePopulation(necessaryPointToTakeNode);

                targetPlayer.decreaseSupply(this.destineNode.config.populationSupply);
                this.owner.increaseSupply(this.destineNode.config.populationSupply);

                this.destineNode.player = this.owner;
                this.destineNode.counter = this.payload.counter;

                this.relatedScene.registry.events.emit('nodeCaptured', this.owner.id, targetPlayer.id);

                // Insufficient to capture node
            } else {
                const nodePointsLost = Math.round(this.payload.counter / this.destineNode.config.defensivePower);
                this.destineNode.counter = Math.max(this.destineNode.counter - nodePointsLost, 0);
                targetPlayer.decreasePopulation(nodePointsLost);
                this.owner.decreasePopulation(this.payload.counter);
            }
        }

        this.destroy();
    }

    onDestroy: (() => void) | null = null;

    public destroy(): void {
        this.tween?.stop();
        super.destroy();

        if (this.onDestroy) {
            this.onDestroy();
        }
    }
}
